import OrderDTO from "@/dto/order/OrderDTO";
import ShopDTO from "@/dto/shop/ShopDTO";
import OrderMergeSplitStatus from "@/enum/OrderMergeSplitStatus";
import ShopType from "@/enum/ShopType";
import { useModalStore } from "@/hooks/Modal/hooks";
import MergeOrderModal, {
    MergeType,
} from "@/scenes/OrderManagement/components/dialogs/MergeOrderDialog/MergeOrderModal";
import { useOrderManagementStore } from "@/scenes/OrderManagement/store/OrderManagementStore";
import { observer } from "mobx-react-lite";
import React from "react";

interface PendingShipmentCountInfoProps {
    order: OrderDTO;
    shop: ShopDTO;
}

interface MergeOrderButtonProps extends PendingShipmentCountInfoProps {
    mergeType: MergeType;
}

export function shouldRenderPendingShipmentCountInfo(order: OrderDTO, shop: ShopDTO) {
    const buyerCount = order.sameBuyerMergeablePendingShipmentCount;
    const consigneeCount = order.sameConsigneeMergeablePendingShipmentCount;

    return !(
        order.mergeSplitStatus === OrderMergeSplitStatus.SPLIT_CHILD ||
        shop.type === ShopType.PDD_FULFILLMENT ||
        !(buyerCount || consigneeCount)
    );
}

const MergeOrderButton: React.FC<MergeOrderButtonProps> = observer(function ({ order, shop, mergeType }) {
    const modalStore = useModalStore();
    const orderManagementStore = useOrderManagementStore();

    const handleClick = (e: React.MouseEvent) => {
        e.preventDefault();
        modalStore.openModal(MergeOrderModal, {
            order,
            onRefresh: () => orderManagementStore.fetchOrders(shop.id),
            mergeType,
        });
    };

    return (
        <a className="a" onClick={handleClick} href="#">
            手工合并
        </a>
    );
});

const PendingShipmentCountInfo: React.FC<PendingShipmentCountInfoProps> = observer(function ({ order, shop }) {
    const {
        sameBuyerMergeablePendingShipmentCount: buyerCount,
        sameConsigneeMergeablePendingShipmentCount: consigneeCount,
        retailerDropShippingInfo,
    } = order;

    if (!shouldRenderPendingShipmentCountInfo(order, shop)) {
        return null;
    }

    const mergeTypes = [
        { type: MergeType.sameBuyer, label: "买家", count: buyerCount },
        { type: MergeType.sameConsignee, label: "收货人", count: consigneeCount },
    ] as const;

    return (
        <div className="text-danger mt5">
            {mergeTypes.map(({ type, label, count }) =>
                count ? (
                    <p key={type}>
                        此{label}还有 {count} 笔待发货订单，
                        {retailerDropShippingInfo ? (
                            <>其中代发订单不能合并</>
                        ) : (
                            <MergeOrderButton order={order} shop={shop} mergeType={type} />
                        )}
                    </p>
                ) : null,
            )}
        </div>
    );
});

export default PendingShipmentCountInfo;
